import { isEnrolledStatus } from "@/types/employeeState";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RootState } from "../store";

const PublicRoute = (): JSX.Element => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user);
  const search = useLocation().search;
  const searchParams = new URLSearchParams(search).toString();
  const isAuthenticated = (): boolean => !!user.id;

  const isLegalPage = (): boolean => {
    const currentPath = location.pathname;
    return (
      currentPath.includes("/help") || currentPath.includes("/sep-introduction")
    );
  };

  if (isAuthenticated() && !isLegalPage()) {
    if (user.IsDefaultPasswordChanged === "True") {
      if (isEnrolledStatus(user.enrolledStatus)) {
        return (
          <Navigate
            to={`/?${searchParams}`}
            state={{ from: location }}
            replace
          />
        );
      } else {
        return (
          <Navigate
            to={`/wizard?${searchParams}`}
            state={{ from: location }}
            replace
          />
        );
      }
    }
  }

  return <Outlet />;
};

export default PublicRoute;
